export default __webpack_public_path__ + "static/media/c(4).90aa41c2.jpg";